import { render, staticRenderFns } from "./AutoTradingPage.vue?vue&type=template&id=40e5f64c&scoped=true"
import script from "./AutoTradingPage.vue?vue&type=script&lang=js"
export * from "./AutoTradingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e5f64c",
  null
  
)

export default component.exports